<template>
  <div>
    <div class="inoformation-view">
      <img src="@/assets/noShipCrew.png" alt="" />
    </div>
  </div>
</template>

<script>
//getAllFile
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
